import { useState } from "react";
import React from "react";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { CircularProgress } from "@mui/material";

export function Components_TimedProgress_ZB2B7FD7(components_TimedProgress_ZB2B7FD7InputProps) {
    const closeTimeMs = components_TimedProgress_ZB2B7FD7InputProps.closeTimeMs;
    const onEnd = components_TimedProgress_ZB2B7FD7InputProps.onEnd;
    const closeTimeMs_1 = defaultArg(closeTimeMs, 1000) | 0;
    const patternInput = useState(0);
    const closeTicks = patternInput[0];
    const timer = reactApi.useRef(-1);
    const finished = reactApi.useRef(false);
    const exited = reactApi.useRef(false);
    const tickIncrease = 100 / ~~(closeTimeMs_1 / 150);
    if (!finished.current && (closeTicks >= 100)) {
        finished.current = true;
        clearInterval(timer.current);
    }
    const dependencies = [finished.current];
    reactApi.useEffect(() => {
        if (finished.current && !exited.current) {
            onEnd();
            exited.current = true;
        }
    }, dependencies);
    useEffectOnce(() => {
        const timerId = setInterval(() => {
            if (!finished.current) {
                patternInput[1]((oldTick) => (oldTick + tickIncrease));
            }
        }, 150) | 0;
        timer.current = timerId;
    });
    return MuiHelpers_createElement(CircularProgress, [["variant", "determinate"], ["color", "inherit"], ["size", 15 + "px"], ["value", ~~closeTicks]]);
}

